import React from "react";
import { FaUserCircle } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { user } = useAuth();

  return (
    <header className="h-16 border-b border-secondary-100 px-8 flex items-center justify-end bg-secondary-100 text-white">
      <div className="flex flex-col items-end text-right">
        <div className="flex items-center gap-2">
          <span className="text-xs md:text-sm font-semibold uppercase">
            {user?.username || "Usuario"}
          </span>
          <FaUserCircle className="text-white text-xl md:text-2xl" />
        </div>
      </div>
    </header>
  );
};

export default Header;
